import React from "react";
import Create from "modules/rejectionReasons/components/Create";

const RejectionReasonsCreatePage = () => {
  return <Create />;
};

export default RejectionReasonsCreatePage;
